import { useEffect, useMemo } from 'react'
import { useAppDispatch, useAppSelector } from '../redux/types/types'
import { getStatsClaims } from '../redux/actions/claimsAction'
import { ClaimResponseType } from '../redux/actions/types'
import { parseDateSafely } from '../utils/date'
import { formatDateForAPI } from '../utils/formatDateForAPI'

interface UseOtherClaimsParams {
  currentClaim: ClaimResponseType
  token: string
  userRole: string
  userCompanyId: number | undefined
}

export const useOtherClaims = ({
  currentClaim,
  token,
  userRole,
  userCompanyId,
}: UseOtherClaimsParams) => {
  const dispatch = useAppDispatch()
  const { statsClaims, isLoadingStatsClaims } = useAppSelector((state) => state.claims)

  useEffect(() => {
    if (currentClaim?.startDate && currentClaim?.endDate && currentClaim?.place?.id && token) {
      const startDate = parseDateSafely(currentClaim.startDate)
      const endDate = parseDateSafely(currentClaim.endDate)

      const startDateStr = formatDateForAPI(startDate)
      const endDateStr = formatDateForAPI(endDate)

      dispatch(
        getStatsClaims({
          token,
          dateRange: {
            start: startDateStr,
            end: endDateStr,
          },
          limit: 1000,
          place: String(currentClaim.place.id),
          companyId: userRole !== 'superAdmin' && userCompanyId ? userCompanyId : null,
        }),
      )
    }
  }, [
    currentClaim?.startDate,
    currentClaim?.endDate,
    currentClaim?.place?.id,
    token,
    dispatch,
    userRole,
    userCompanyId,
  ])

  const otherClaims = useMemo(() => {
    if (!currentClaim?.id || !statsClaims || statsClaims.length === 0) {
      return []
    }

    return statsClaims.filter((claim: ClaimResponseType) => {
      if (claim.id === currentClaim.id) {
        return false
      }

      if (claim.status === 'inAnticipation') {
        return false
      }

      return true
    })
  }, [statsClaims, currentClaim])

  return {
    otherClaims,
    isLoadingStatsClaims,
  }
}
